import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
// @ts-ignore
import { filteringENTrans, filteringFRTrans } from 'hse-filtering-library-frontend';
import messages_fr from './translations/messages_fr';
import messages_en from './translations/messages_en';

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: 'en',
    fallbackLng: 'en',
    load: 'languageOnly',
    preload: ['en', 'fr'],
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: { useSuspense: false },
    resources: {
      en: {
        translation: messages_en,
        filtering: filteringENTrans,
      },
      fr: {
        translation: messages_fr,
        filtering: filteringFRTrans,
      },
    },
  });

export const t = (key: string, vars: any) => i18n.t(key, vars);

export default i18n;
